import { combineReducers } from "@reduxjs/toolkit";
import modalReducer from "./modalReducer";
import userReducer from "./userReducer";
import notificationReducer from "./notificationReducer";
import snackBarReducer from "./snackbarReducer";
import BeneficiaryReducer from "./BeneficiaryReducer";
import oscillaReducer from "./oscillaReducer";

const rootReducer = combineReducers({
  user: userReducer,
  modal: modalReducer,
  notifications: notificationReducer,
  Beneficiary: BeneficiaryReducer,
  snackBar: snackBarReducer,
  oscilla: oscillaReducer,
});
export default rootReducer;
